import { STAGE } from '@src/constants'

export const LOCAL_STORAGE_CACHE_KEY = `local-map/${STAGE}/user-location`
